export const SOLUTIONS = Object.freeze({
  ENTERPRISE: "enterprise",
  PRO: "pro",
  EDUCATOR: "educator",
  SPORTS: "sports",
});

export const SOLUTIONS_DISPLAY = Object.freeze({
  ENTERPRISE: "enterprise",
  PRO: "DBC",
  EDUCATOR: "student",
  SPORTS: "athlete",
});
